<div class="header-wrapper">
  <mat-slide-toggle labelPosition="before" [formControl]="shareWithAll">Share with ALL my Friends
  </mat-slide-toggle>
  <mat-slide-toggle labelPosition="before" [disabled]="(shareWithAll.value === false && !selectedFriends().size)" [formControl]="shareWithAcquaintances">
    Share with acquaintances
    <ng-icon class="info-icon" name="heroInformationCircle"
      matTooltip="Friends of your friends. People whom you don't know but trust because they know your friends.">
    </ng-icon>
  </mat-slide-toggle>
</div>

@if (!shareWithAll.value) {
  <div class="friends-actions">
    <div class="actions">
      <div class="search-box">
        <span class="search-icon">
          <app-icon size="medium" color="#9BB2DD" name="search"></app-icon>
        </span>
        <input [formControl]="search" type="text" placeholder="Search"/>
      </div>
    </div>
  </div>

  <div #scrollFriendsContainer class="grid-container" (scroll)="onFriendsScroll()">
    @for (friend of friendsList(); track friend.id) {
      <app-share-friend-card
        (selectChanged)="changedFriendSelection($event)"
        [friend]="friend"
        [checked]="(friend?.selected ?? false)"
      ></app-share-friend-card>
    }
  </div>
}
